function isPlainObject(value) {
    return (value != null &&
        typeof value === 'object' &&
        !Array.isArray(value) &&
        (value.constructor === Object || value.constructor === undefined));
}
function deepMerge(target, source) {
    const output = target;
    for (const key of Object.keys(source)) {
        const sourceValue = source[key];
        const targetValue = output[key];
        if (isPlainObject(sourceValue)) {
            // never adopt the source's object by reference: bundlers emit frozen
            // namespace objects (`export * as X`), so a later merge into the same
            // slot would throw ("object is not extensible"). Always merge into a
            // fresh, extensible object instead.
            output[key] = deepMerge(isPlainObject(targetValue) ? targetValue : {}, sourceValue);
        }
        else if (Array.isArray(sourceValue)) {
            output[key] = sourceValue.slice();
        }
        else {
            output[key] = sourceValue;
        }
    }
    return output;
}
export class DeepMerger {
    constructor() {
    }
    static merge(source, target) {
        target ??= (globalThis['Pacem'] ??= {});
        return deepMerge(target, source);
    }
}
